"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SecondaryNav;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _useObserverListener = require("@site/pattern-library-utils/hooks/useObserverListener");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _index = _interopRequireDefault(require("../../../elements/other/actions/index.js"));
var _navItem = _interopRequireDefault(require("./nav-item.js"));
var _animation = require("../../../animation");
var _core = require("@linaria/core");
var _text = _interopRequireDefault(require("@ux/text"));
var _navLink = _interopRequireDefault(require("./common/nav-link.js"));
var _mobileNavLink = _interopRequireDefault(require("./common/mobile-nav-link.js"));
var _nestedNavItem = _interopRequireDefault(require("./nested-nav-item.js"));
var _index2 = _interopRequireDefault(require("../../../experiments/animation/motion-move/index.js"));
var _useSticky = require("../../other/sticky-stack/use-sticky.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SecondaryNavContainer = /*#__PURE__*/(0, _react2.styled)("nav")({
  name: "SecondaryNavContainer",
  class: "pl-spkhoww",
  vars: {
    "spkhoww-3": [({
      invert
    }) => invert ? _intents.default.ux.box.foregroundColor : _intents.default.ux.boxLowContrast.borderColor]
  }
});
const CategoryTitle = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CategoryTitle",
  class: "pl-c1doczga"
});
const NavBar = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavBar",
  class: "pl-nwr8738",
  vars: {
    "nwr8738-0": [({
      invert
    }) => invert ? _intents.default.ux.boxHighContrast.foregroundColor : ''],
    "nwr8738-1": [({
      isTransparent,
      invert
    }) =>
    // eslint-disable-next-line no-nested-ternary
    isTransparent ? 'transparent' : invert ? _intents.default.ux.box.foregroundColor : _intents.default.ux.box.backgroundColor]
  }
});
const IconChevronDown = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconChevronDown",
  class: "pl-i1yk64jc",
  vars: {
    "i1yk64jc-1": [({
      expanded
    }) => expanded ? 'rotate(-180deg)' : 'rotate(0)']
  }
});
const DesktopMenu = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "DesktopMenu",
  class: "pl-d1rxsvtj"
});
const DropdownList = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "DropdownList",
  class: "pl-d1pza8v1"
});
const DropdownLink = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "DropdownLink",
  class: "pl-d1h5523j"
});
const MenuOverlay = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MenuOverlay",
  class: "pl-m1j8gx9a",
  vars: {
    "m1j8gx9a-0": [({
      show
    }) => show ? 'static' : 'none']
  }
});
const MobileMenu = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "MobileMenu",
  class: "pl-m5n4g11",
  vars: {
    "m5n4g11-0": [({
      expanded
    }) => expanded ? 'flex' : 'none']
  }
});
const MobileMenuDropdown = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "MobileMenuDropdown",
  class: "pl-my7uw9e"
});
const MobileMenuItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "MobileMenuItem",
  class: "pl-mkq8sqq"
});
const MobileMenuGroup = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobileMenuGroup",
  class: "pl-m1bjubn6"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonContainer",
  class: "pl-b103c78y"
});
const legal = "pl-l7swzq6";
const MoreButton = /*#__PURE__*/(0, _react2.styled)(_navItem.default)({
  name: "MoreButton",
  class: "pl-mcqburx",
  vars: {
    "mcqburx-1": [({
      hide
    }) => hide ? 'none' : 'flex']
  }
});
const overlayAnimation = "pl-o16ov9yj";
const dropdownAnimation = "pl-d1bmewce";
const chevronOpen = "pl-c114hrru";
const chevronClose = "pl-cbtj9jx";
const resolveObservedID = id => {
  if (typeof id === 'object') {
    return `id-${id?.id}`;
  }
  return id;
};
/**
 * Secondary Nav Component
 * @module SecondaryNav
 *
 * @param {Object} props React props
 * @param {string} props.disclaimer Legal Text
 * @param {Object} props.secondaryNav SecondaryNav Object contains menu items and nav title
 * @param {array} props.secondaryNav.items array of menu items
 * @param {string} props.secondaryNav.title secondary nav title
 * @param {Object} props.cta CTA Object
 * @param {string} props.moreText More text string
 * @param {boolean} props.isSticky isSticky option
 * @param {boolean} props.isTransparent isTransparent option
 * @param {boolean} props.invert theme invert option
 * @returns {React.ReactElement} SecondaryNav Component
 * @public
 */
// eslint-disable-next-line max-statements
function SecondaryNav({
  _name,
  disclaimer,
  secondaryNav: {
    title: navTitle,
    items: navItems
  },
  moreText = 'More',
  cta,
  isSticky = false,
  isTransparent = false,
  invert = false,
  observedElement,
  partial = ''
}) {
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const [expandedGroup, setExpandedGroup] = (0, _react.useState)(false);
  const [liveList, setLiveList] = (0, _react.useState)(navItems);
  const [showMore, setShowMore] = (0, _react.useState)(false);
  const [moreMenuItems, setMoreMenuItems] = (0, _react.useState)([]);
  const [moreIndex, setMoreIndex] = (0, _react.useState)(0);
  const containerRef = (0, _react.useRef)(null);
  const listMenuRef = (0, _react.useRef)(null);
  const moreMenuRef = (0, _react.useRef)(null);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const {
    isMobile
  } = (0, _patternLibraryUtils.useDeviceDetect)();
  _patternLibraryUtils.tracking.useTracking(containerRef);
  const trackingProps = _patternLibraryUtils.tracking.props(_name, false, true);
  const {
    isStickyState
  } = (0, _useSticky.useSticky)('secondary-nav', containerRef, isSticky);
  const hasIntersectedObserved = (0, _useObserverListener.useHasIntersectedWithElement)(resolveObservedID(observedElement), containerRef, {
    initialValue: !observedElement
  });
  const scrollToAnchor = event => {
    event.preventDefault();
    const target = event.currentTarget?.dataset?.target;
    const element = document.getElementById(target);
    if (element && typeof window !== 'undefined') {
      setExpanded(false);
      setExpandedGroup(false);
      setTimeout(() => {
        window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - (isStickyState ? 88 : 16)
        });
      }, 100);
    }
    return null;
  };
  const handleKeyPress = ({
    key
  }) => {
    if (key === 'Enter') {
      setExpanded(!expanded);
    }
  };
  function resetMoreMenu() {
    setShowMore(false);
    setMoreMenuItems([]);
  }
  function toggleGroup(id) {
    id === expandedGroup ? setExpandedGroup(-1) : setExpandedGroup(id);
  }
  (0, _patternLibraryUtils.useIsomorphicLayoutEffect)(() => {
    function checkFormatMoreMenu() {
      if (listMenuRef?.current) {
        const moreItemWidth = moreMenuRef?.current?.offsetWidth,
          listWidth = listMenuRef.current.offsetWidth,
          availableWidth = listWidth,
          listItems = Array.from(listMenuRef.current.children);
        const marginPixels = 32;
        let itemsWidth = moreItemWidth + marginPixels;
        let limit = false;
        for (let i = 0; i < listItems?.length; i++) {
          itemsWidth += listItems[i].offsetWidth + marginPixels;
          if (!limit && itemsWidth > availableWidth) {
            const moreItems = liveList.slice(i);
            limit = true;
            if (moreItems?.length > 0) {
              setShowMore(true);
              setMoreMenuItems(moreItems);
            } else {
              resetMoreMenu();
            }
          }
          if (limit) {
            if (listItems[i] !== moreMenuRef.current) {
              listItems[i].style.order = i + 1;
            }
          }
        }
        if (!limit) {
          resetMoreMenu();
        }
      }
    }
    if (!isMobile) {
      checkFormatMoreMenu();
    }
  }, [isMobile, width, liveList]);
  (0, _patternLibraryUtils.useIsomorphicLayoutEffect)(() => {
    setMoreIndex(liveList?.length - moreMenuItems?.length);
  }, [liveList, moreMenuItems]);
  (0, _react.useEffect)(() => {
    const exitOnClick = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setExpanded(expanded);
      }
    };
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', exitOnClick, false);
      return () => {
        document.removeEventListener('mousedown', exitOnClick, false);
      };
    }
  }, [expanded]);
  (0, _react.useEffect)(() => {
    const currList = [...liveList];
    const isActiveEntrySet = currList.find(entry => entry?.active);
    if (global?.location && !isActiveEntrySet) {
      const decodedPathName = decodeURIComponent(global.location.pathname);
      const regExp = new RegExp((decodedPathName || '').replace(/\/$/, ''));
      const activeItem = currList.find(entry => entry?.href?.match(regExp) !== null);
      if (activeItem) {
        activeItem.active = true;
      } else if (currList && currList[0]) {
        currList[0].active = true;
      }
      setLiveList([...currList]);
    }
  }, [liveList]);
  (0, _patternLibraryUtils.useExitOnEscape)(setExpanded);
  const getDropDownList = dropDownList => /*#__PURE__*/_react.default.createElement(DropdownList, {
    "data-cy": "dropdown-list",
    "data-partial": partial || (invert ? 'dark1' : '')
  }, dropDownList?.map(({
    _name: itemName,
    href,
    active,
    title,
    items
  }, i) => {
    if (items && items[0]?.items) {
      return /*#__PURE__*/_react.default.createElement(DropdownLink, {
        key: i
      }, /*#__PURE__*/_react.default.createElement(_nestedNavItem.default, {
        tabIndex: 0,
        order: i,
        itemText: title
      }, items[0].items.map((nestedItem, nestedIndex) => /*#__PURE__*/_react.default.createElement("li", {
        key: nestedIndex,
        "data-cy": "nested-link"
      }, /*#__PURE__*/_react.default.createElement(_navLink.default, {
        _name: nestedItem._name,
        href: nestedItem.href,
        title: nestedItem.title,
        tabIndex: 0
      })))));
    }
    return /*#__PURE__*/_react.default.createElement(DropdownLink, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_navLink.default, {
      i: i,
      _name: itemName,
      href: href,
      title: title,
      active: active,
      tabIndex: 0,
      scrollToAnchor: scrollToAnchor
    }));
  }));
  const mobileMenu = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MobileMenu, {
    className: dropdownAnimation,
    "data-cy": "mobile-menu",
    expanded: expanded
  }, liveList?.map(({
    _name: itemName,
    href,
    title,
    active,
    anchor,
    items
  }, i) => {
    const itemsAreChildren = items?.length === 1 && items[0]._name === 'children';
    const itemList = itemsAreChildren ? items[0].items : items;
    return items?.length > 0 && itemList ? /*#__PURE__*/_react.default.createElement(MobileMenuDropdown, {
      key: i,
      tabIndex: 0,
      onClick: () => toggleGroup(i),
      onKeyPress: ({
        key
      }) => {
        if (key === 'Enter') {
          toggleGroup(i);
        }
      }
    }, /*#__PURE__*/_react.default.createElement(MobileMenuGroup, null, title, /*#__PURE__*/_react.default.createElement(IconChevronDown, {
      "data-cy": "down-chevron",
      className: "group-chevron"
    }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "chevron-down",
      className: expandedGroup === i ? chevronOpen : chevronClose
    }))), expandedGroup === i && itemList?.map((value, index) => /*#__PURE__*/_react.default.createElement(MobileMenuItem, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_mobileNavLink.default, {
      _name: value._name,
      href: value.href,
      title: value.title,
      active: value.active,
      anchor: value.anchor
    })))) : /*#__PURE__*/_react.default.createElement(MobileMenuItem, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_mobileNavLink.default, {
      _name: itemName,
      href: href,
      title: title,
      active: active,
      anchor: anchor
    }));
  })), /*#__PURE__*/_react.default.createElement(MenuOverlay, {
    className: overlayAnimation,
    show: expanded
  }));
  function getMenuItems() {
    return liveList.map(({
      _name: itemName,
      href,
      title,
      active,
      items,
      anchor
    }, i) => {
      const itemsAreChildren = items?.length === 1 && items[0]._name === 'children';
      const itemList = itemsAreChildren ? items[0].items : items;
      return items?.length > 0 && itemList ? /*#__PURE__*/_react.default.createElement(_navItem.default, {
        key: i,
        _name: itemName,
        tabIndex: 0,
        order: i,
        invert: invert,
        itemText: title,
        hide: i >= moreIndex
      }, getDropDownList(itemList)) : /*#__PURE__*/_react.default.createElement(_navItem.default, {
        key: i,
        _name: itemName,
        order: i,
        "data-active": active,
        invert: invert,
        hide: i >= moreIndex,
        itemText: /*#__PURE__*/_react.default.createElement(_navLink.default, {
          i: i,
          _name: itemName,
          href: href,
          title: title,
          active: active,
          anchorId: anchor,
          "data-partial": partial || (invert ? 'dark1' : ''),
          tabIndex: i >= moreIndex ? -1 : 0,
          scrollToAnchor: scrollToAnchor
        })
      });
    });
  }
  return /*#__PURE__*/_react.default.createElement(SecondaryNavContainer, (0, _extends2.default)({
    id: "secondary-nav",
    "data-cy": "secondary-nav",
    ref: containerRef,
    isTransparent: isTransparent
  }, trackingProps, {
    "data-partial": partial || (invert ? 'dark1' : '')
  }), /*#__PURE__*/_react.default.createElement(NavBar, {
    isTransparent: isTransparent
  }, /*#__PURE__*/_react.default.createElement(CategoryTitle, {
    "data-cy": "nav-title",
    onClick: () => setExpanded(!expanded),
    onKeyPress: e => handleKeyPress(e),
    tabIndex: width > _patternLibraryUtils.size.laptop ? -1 : 0,
    "data-partial": partial || (invert ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement(IconChevronDown, {
    "data-cy": "down-chevron",
    className: "title-chevron"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down",
    className: expanded ? chevronOpen : chevronClose
  })), navTitle), /*#__PURE__*/_react.default.createElement(DesktopMenu, {
    "data-cy": "list-menu",
    ref: listMenuRef
  }, getMenuItems(), /*#__PURE__*/_react.default.createElement(MoreButton, {
    ref: moreMenuRef,
    _name: "more-button-link",
    tabIndex: 0,
    order: moreIndex,
    hide: !showMore,
    dataCy: "moreMenu",
    itemText: moreText
  }, getDropDownList(moreMenuItems))), /*#__PURE__*/_react.default.createElement(ButtonContainer, {
    "data-partial": partial
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    className: legal,
    size: -2
  }, disclaimer), cta && (hasIntersectedObserved || isMobile) && /*#__PURE__*/_react.default.createElement(_index2.default, {
    mode: "swift",
    variant: "appear",
    intensity: "300",
    triggerOnce: true
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...cta,
      size: 'small'
    }]
  })))), mobileMenu);
}
SecondaryNav.propTypes = {
  _name: _propTypes.default.string,
  disclaimer: _propTypes.default.string,
  isSticky: _propTypes.default.bool,
  isTransparent: _propTypes.default.bool,
  secondaryNav: _propTypes.default.shape({
    title: _propTypes.default.string,
    items: _propTypes.default.array
  }),
  moreText: _propTypes.default.string,
  invert: _propTypes.default.bool,
  cta: _propTypes.default.shape({
    ..._merchButton.NSMerchButton.propTypes
  }),
  partial: _propTypes.default.string,
  observedElement: _propTypes.default.oneOfType([_propTypes.default.shape({
    id: _propTypes.default.string
  }), _propTypes.default.string])
};